import React, { useEffect } from 'react';

// Generic dropdown that populates from a list of names and pre-selects
// the entry matching a clicked calendar event.
//
// Props:
//   selectID     — appended to "entitySelectDropdown" to form the element ID
//   listNames    — array of name strings to populate the dropdown
//   eventClickedObj — the FullCalendar event click arg (optional)
//   matchField   — the extendedProps key to match against (e.g. "caretaker" or "client")
export const EntitySelect = (props) => {

    useEffect(() => {
        const dropdown = document.getElementById("entitySelectDropdown" + props.selectID);
        dropdown.innerHTML = "";

        for (let i = 0; i < props.listNames.length; i++) {
            const option = document.createElement("option");
            option.text = props.listNames[i];
            dropdown.appendChild(option);
        }

        for (let i = 0; i < props.listNames.length; i++) {
            if (props.eventClickedObj &&
                props.eventClickedObj.extendedProps[props.matchField] === props.listNames[i]) {
                dropdown.selectedIndex = i;
                break;
            }
        }
    });

    return (
        <div>
            <select id={"entitySelectDropdown" + props.selectID}></select>
        </div>
    );
};
